import React from "react";
import {
  imageWrapper,
  iconWrapper,
  wrapper
} from "./NoActiveMembershipImage.css";

export const NoActiveMembershipImage: React.FC = () => {
  return (
    <div className={wrapper}>
      <img
        src="/images/membership/discovery-journey/welcome-slide.png"
        alt="member-perks"
        className={imageWrapper}
      />
      <div className={iconWrapper}>
        <img
          src="/images/membership/discovery-journey/no-active-membership-warning.png"
          alt="member-perks"
        />
      </div>
    </div>
  );
};
